module.exports = __webpack_public_path__ + "img/logo_aspekid.85618646.png";